import { Link } from "react-router-dom"; // Dùng cho internal link
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

// Dữ liệu team
import { teamData } from "../data/teamData";

// Social icons tái sử dụng
const socialIcons = [
  { icon: <FaFacebookF />, key: "facebook" },
  { icon: <FaTwitter />, key: "twitter" },
  { icon: <FaInstagram />, key: "instagram" },
  { icon: <FaLinkedinIn />, key: "linkedin" },
];

const TeamSection = () => {
  return (
    <section className="team-section fix section-padding">
      <div className="container">
        {/* Section title */}
        <div className="section-title text-center">
          <h6 className="wow fadeInUp">Đội Ngũ Design24</h6>
          <h2
            className="wow fadeInUp"
            data-wow-delay=".3s"
          >
            Gặp Gỡ <span>Những Người Đồng Hành</span>
          </h2>
        </div>

        {/* Team list */}
        <div className="row">
          {teamData.map((member, index) => (
            <div
              key={member.id}
              className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay={`${0.2 + index * 0.2}s`}
            >
              <div className="team-box-items">
                <div className="team-image">
                  <img
                    src={member.homeImg}
                    alt={member.name}
                  />
                  <div className="social-icon">
                    {socialIcons.map(
                      (s, i) =>
                        member.socials[s.key] ? (
                          <a
                            key={i}
                            href={member.socials[s.key]}
                            className="icon"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {s.icon}
                          </a>
                        ) : null // ẩn nếu không có link
                    )}
                  </div>
                </div>
                <div className="team-content">
                  <h3>
                    <Link to={`/doi-ngu/${member.slug}`}>{member.name}</Link>
                  </h3>
                  <p>{member.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
